import styled from '@emotion/styled'

const Backdrop = styled('div')({
    position: 'fixed',
    zIndex: -1,
    opacity: 0,
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'saturate(0.5) brightness(0.75)',
    // background: palette.backdrop,
    transition: 'all 0.4s linear',
})

export default Backdrop
